import { render, staticRenderFns } from "./dialog-form.vue?vue&type=template&id=5e5980b6&scoped=true&"
import script from "./dialog-form.vue?vue&type=script&lang=js&"
export * from "./dialog-form.vue?vue&type=script&lang=js&"
import style0 from "./dialog-form.vue?vue&type=style&index=0&id=5e5980b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5980b6",
  null
  
)

export default component.exports